import React, { JSX, useEffect } from "react";

import { CometChat } from "@cometchat/chat-sdk-javascript";

function Hooks(
    loggedInUser: any,
    setLoggedInUser: Function,
    subscribeToEvents: any,
    attachListeners: any,
    onErrorCallback: any,
    ccBackBtnElement: JSX.IntrinsicElements["cometchat-button"],
    onBackRef:  React.MutableRefObject<() => void>,
    userRef: React.MutableRefObject<CometChat.User | undefined>, 
    groupRef: React.MutableRefObject<CometChat.Group | undefined>,
    updateSubtitle: Function
) {
    useEffect(
        () => {
            CometChat.getLoggedinUser().then(
                (userObject: CometChat.User | null) => {
                    if (userObject) {
                        setLoggedInUser(userObject);
                    }
                }, (error: CometChat.CometChatException) => {
                    onErrorCallback(error);
                }
            );
        },
        [setLoggedInUser, onErrorCallback]
    );

    useEffect(()=>{
        const removeListenerFns : (() => void)[] = [];
        if(loggedInUser){
            removeListenerFns.push(subscribeToEvents());
            removeListenerFns.push(attachListeners());
        }
        return () => {
            for (let i = 0; i < removeListenerFns.length; i++) {
                return removeListenerFns[i]();
            }
        }
    }, [loggedInUser, attachListeners, subscribeToEvents]);

    useEffect(
        () => {
            if (!ccBackBtnElement) return;
            const eventName = "cc-button-clicked";
            const onBackClicked = () => onBackRef.current?.();
            ccBackBtnElement.addEventListener(eventName, onBackClicked);
            return () => {
                ccBackBtnElement.removeEventListener(eventName, onBackClicked);
            }
        },
        [ccBackBtnElement, onBackRef]
    );

    useEffect(() => {
        updateSubtitle();
    }, [userRef.current, groupRef.current, updateSubtitle])
}

export { Hooks };
